import { FILE_STATUS, SOURCE_FILE_TYPES } from 'enums'
import { isArray, isNil, uniq } from 'lodash'
import { getAssets } from '~/selectors'
import * as API from '~/ServerAPI'
import * as ActionTypes from '~/actions/ActionTypes'
import { saveProjectFileIds } from './projectData/saveProject'
import { isSourceFile } from '~/helpers/assets/fetchFile'
import { checkFilesInBatches } from './sourceFiles'
import { selectActiveProject, selectActiveProjectId } from '~/selectors/projectData'


export const getProjectMediaFiles = async fileIds => {
  if (!isArray(fileIds)) return []

  const queue = uniq(fileIds)
  const MAX_REQUESTS = 5
  const successResults = []
  const errorResults = []

  while (queue.length > 0) {
    const batch = queue.splice(0, MAX_REQUESTS)
    const requests = batch.map(id => API.getMediaFile(id)
      .then(({ data }) => data)
      .catch(e => {
        console.error(`error on loading file ${id}:`, e)
        errorResults.push(id)
        return null
      }))

    // eslint-disable-next-line
    const responses = await Promise.all(requests)
    successResults.push(...responses.filter(data => data !== null && isSourceFile(data.id)))
  }

  return [ successResults, errorResults ]
}

export const loadProjectMedia = projectId => async (dispatch, getState) => {
  const state = getState()
  const project = selectActiveProject(state)
  const activeProjectId = selectActiveProjectId(state)

  if (!isNil(projectId)) {
    if (activeProjectId !== projectId) {
      return
    }
  }
  const allAssets = getAssets(state)
  const assetFileIds = allAssets.map(a => a.fileId)
  const projectFields = Array.isArray(project?.fileIds) ? project?.fileIds : []
  const finishAssetFileIds = assetFileIds.filter(Boolean)
  const fileIds = Array.from(new Set([ ...projectFields, ...finishAssetFileIds ]))
  dispatch({
    type: ActionTypes.SOURCE_FILES_REQUESTED,
    payload: { type: SOURCE_FILE_TYPES.PROJECT_MEDIA },
  })

  try {
    const [ items, errorItems ] = await getProjectMediaFiles(fileIds)
    await dispatch({
      type: ActionTypes.SOURCE_FILES_LOADED,
      payload: {
        type: SOURCE_FILE_TYPES.PROJECT_MEDIA,
        start: 0,
        items,
        totalCount: undefined,
      },
    })
    dispatch(saveProjectFileIds(errorItems, true))
    dispatch(saveProjectFileIds(items.map(item => item.id)))

    const projectFileIds = getState().projectData.activeProject?.fileIds || []
    const checkFileIds = projectFileIds.filter(pf => items.find(
      file => (pf === file.id && file.status !== FILE_STATUS.READY)
    ))
    dispatch(checkFilesInBatches(checkFileIds, SOURCE_FILE_TYPES.PROJECT_MEDIA, undefined))
  } catch (error) {
    error.type = SOURCE_FILE_TYPES.PROJECT_MEDIA
    dispatch({
      type: ActionTypes.SOURCE_FILES_LOADED,
      payload: error,
      error: true,
    })
    console.error(`Failed to fetch source files type ${SOURCE_FILE_TYPES.PROJECT_MEDIA}\n`, error)
  }
}
